module.exports = __webpack_public_path__ + "static/media/HolisticTreatment.d1c236e4.png";